import React, { useState } from "react";
import { Modal, Button, Form, FormControl } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { agent } from "../../utils/agent";
import * as API from "../../utils/apiPath";
import PopupModalWithOk from "../../utils/helpers/popupModalOk";

const Subscribe = (props) => {

  const { register: register2, handleSubmit: handleSubmit2, formState: { errors: errors2 } } = useForm({});
  const [getLoader, setGetLoader] = useState(false);
  const [subsModalShow, setSubsModalShow] = useState(false);
  const hideModal = () => setSubsModalShow(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  const onSubmitSubsEmail = data => {
    setGetLoader(true);
    agent
      .post(API.SAVESUBSCRIBTIONEMAIL, data)
      .then((res) => {
        const message = res?.data?.message || "Record has been updated successfully.";
        setGetLoader(false);
        if (res.data.data === true) {
          setSubsModalShow(false);
          setPopupMessage(message);
          setShowPopup(true);
        }
        if (res.data.data === false) {
          setPopupMessage(message);
          setShowPopup(true);
        }
      })
      .catch((err) => {
        setPopupMessage(err);
        setShowPopup(true);
      });
  };

  React.useEffect(() => {
    let pop_status = localStorage.getItem('pop_status');
    if (pop_status != 1 && !localStorage.getItem('userToken')) {
      setSubsModalShow(true);
      localStorage.setItem('pop_status', 1);
    }
  }, [])

  return (
    <>
      <section className="start-building">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="text-center">
                <div className="title">
                  Subscribe to our newsletter{" "}
                  <span className="d-block">to stay updated with vLookUp!</span>
                </div>
                <button type="button" className="btn" onClick={() => setSubsModalShow(true)} >
                  Subscribe
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        id="SubsModal"
        centered
        show={subsModalShow}
        onHide={hideModal} className="calendar-modal"
      >
        <Modal.Header closeButton>Subscribe to our newsletter</Modal.Header>
        <Modal.Body>
          <div>
            <Form
              onSubmit={handleSubmit2(onSubmitSubsEmail)}
              className="banner_form signup_class"
            >
              <Form.Group controlId="formSubsEmail" style={{ marginTop: "1rem", marginBottom: '1rem' }}>
                <FormControl
                  type="email"
                  placeholder="Email Address"
                  className={errors2.email ? "formError" : ""}
                  {...register2("email", {
                    required: "Please enter your email address",
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: "Invalid email address",
                    },
                    maxLength: {
                      value: 50,
                      message: "Your email should contain max 50 characters",
                    },
                  })}
                  aria-invalid={errors2.email ? "true" : "false"}
                />
                {errors2.email && (
                  <span role="alert" className="err_msg">
                    {errors2.email.message}
                  </span>
                )}
              </Form.Group>
              <Button
                type="submit"
                disabled={getLoader}
                title="Submit"
                className="btn btn-signup"
              >
                {getLoader ? "Loading..." : "Submit"}
              </Button>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
      <PopupModalWithOk
        show={showPopup}
        onHide={() => setShowPopup(false)}
        message={popupMessage}
        showConfirm={false}
        staticBackdrop={true}
      />
    </>
  );
};

export default Subscribe;
